const defaultPlateSteelGrade = {
    name: 'S355JR/J0/J2/K2'
};

export default defaultPlateSteelGrade;
